type MessageSanitizer = (message: string) => string | null;

/**
 * List of sanitizers applied in order. Each receives the original message
 * and returns a transformed message, or null to pass through to the next.
 */
const sanitizers: MessageSanitizer[] = [
  // Hide internal URLs/references from the user
  msg => (/netbsa/i.test(msg) ? 'An internal error occurred' : null),
];

/**
 * Sanitizes an API error message for display.
 * Runs through registered sanitizers in order; returns the first match
 * or the original message if none match.
 */
export function sanitizeErrorMessage(message: string): string {
  for (const sanitizer of sanitizers) {
    const result = sanitizer(message);
    if (result !== null) return result;
  }
  return message;
}
